import React from 'react';
import { WrenchIcon, FlameIcon } from 'lucide-react';
import { ProductPack } from '../pack/ProductPack';
import { CtaButton } from '../CtaButton';
import { TrustLine } from '../TrustLine';
import { modules } from '../../data/modules';
export function FinalCta() {
  return <section className="bg-navy px-5 py-7 text-center text-white" data-id="element-42" data-mp="1so2sok48wkbi">
      <div className="mx-auto max-w-[520px]" data-id="element-43" data-mp="1sm89pbcjb2a2">
        <p className="font-display text-[9px] uppercase tracking-[0.3em] text-gold" data-id="element-44" data-mp="1ens09cnaexo8">One last question</p>
        <h2 className="mt-1 font-display text-[21px] uppercase leading-[1.05] md:text-[24px]" data-id="element-45" data-mp="1iq56s39uyzm2">
          When a diesel engine comes in with a fault… do you
          <br className="hidden md:block" data-id="element-46" data-mp="14s84qrcmy100" /> immediately know what to test first?
        </h2>
        <p className="mx-auto mt-2 max-w-[460px] text-[11.5px] leading-[1.6] text-white/80" data-id="element-47" data-mp="19rb2rru776yh">
          Stop jumping between possible causes. Open the system. Find the symptom. Follow the diagnostic path.{' '}
          <strong className="font-bold text-white" data-id="element-48" data-mp="340vk1tt4j6r1">Scan. Test. Diagnose.</strong>
        </p>
        <div className="mt-3 flex justify-center" data-id="element-49" data-mp="270hmna25mah">
          <ProductPack width={170} data-id="element-50" data-mp="3tg7k4hq4jtv0" />
        </div>
        <p className="mt-2 flex items-center justify-center gap-1.5 font-display text-[16px] uppercase text-gold" data-id="element-51" data-mp="3tdlguua9o0il">
          <WrenchIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="6ztl77tsiokz" /> Diesel Diagnostic Pro™
        </p>
        <p className="font-display text-[9.5px] uppercase tracking-[0.03em] text-white/85" data-id="element-53" data-mp="3ffn0jjcdxu0g">
          The complete visual fault-finding system for diesel technicians
        </p>
        <p className="font-display text-[9.5px] uppercase tracking-[0.05em] text-white/85" data-id="element-54" data-mp="3aimuh8fjcr9c">{modules.map(m => m.short).join(' • ')}</p>
        <p className="mt-2 flex items-center justify-center gap-1 font-display text-[11px] uppercase tracking-[0.03em] text-gold" data-id="element-55" data-mp="3jgqicbdzu04b">
          <FlameIcon className="h-3 w-3 text-[#F26B1D]" aria-hidden="true" data-id="element-56" data-mp="13oszp4kywmlm" /> Get the complete system today
        </p>
        <div className="mt-2 flex justify-center" data-id="element-57" data-mp="yqrg8ijmql9m">
          <CtaButton data-id="element-58" data-mp="3sjseiyn3dc5r">Get Diesel Diagnostic Pro™</CtaButton>
        </div>
        <div className="mt-1.5" data-id="element-59" data-mp="1co9uaef620i">
          <TrustLine data-id="element-60" data-mp="1bwm1lr2d8ks" />
        </div>
      </div>
    </section>;
}